<ion-list>
  <div class="list-ctn">
    <ion-list-header>
      <ion-label *ngIf="isBookletOverview">
        {{ '_create_new_booklet_' | translate }}
      </ion-label>
      <ion-label *ngIf="isSocialMedia">{{ '_create_new_social_media_post_' | translate }}</ion-label>
    </ion-list-header>
    <ng-container *ngIf="isSocialMedia">
      <div *ngIf="showRegularPost" class="premium-option" (click)="onCreate('regular')">
        <ion-item button detail="false">
          <ion-icon name="megaphone-outline"></ion-icon>
          {{ '_regular_posts_' | translate }}
        </ion-item>
      </div>
      <div *ngIf="showJatak" class="premium-option" (click)="onCreate('jatak')">
        <ion-item button detail="false">
          <ion-icon name="chatbox-ellipses-outline"></ion-icon>
          {{ '_jatak_offers_' | translate }}
        </ion-item>
      </div>
      <div *ngIf="showJatak" class="premium-option" (click)="onCreate('challenge')">
        <ion-item button detail="false">
          <ion-icon name="heart-outline"></ion-icon>
          {{ '_jatak_plus_offer_' | translate }}
        </ion-item>
      </div>

      <div *ngIf="showCompetition" class="premium-option" (click)="onCreate('competition')">
        <ion-item button detail="false">
          <ion-icon name="ribbon-outline"></ion-icon>
          {{ '_competition_' | translate }}
        </ion-item>
      </div>

      <div *ngIf="showAuction" class="premium-option" (click)="onCreate('auction')">
        <ion-item button detail="false">
          <ion-icon name="hand-right-outline"></ion-icon>
          {{ '_auction_' | translate }}
        </ion-item>
      </div>

        <div *ngIf="showSpinning" class="premium-option" (click)="onCreate('wheel')">
            <ion-item button detail="false">
                <ion-icon name="flower-outline"></ion-icon>
                {{ '_spinning_wheel_' | translate }}
            </ion-item>
        </div>

      <div *ngIf="showCard" class="premium-option" (click)="onCreate('card')">
        <ion-item button detail="false">
          <ion-icon name="apps-outline"></ion-icon>
          {{ '_scratch_card_' | translate }}
        </ion-item>
      </div>

      <div *ngIf="showRedmad" class="premium-option" (click)="onCreate('redmad')">
        <ion-item button detail="false">
          <ion-icon name="bag-add-outline"></ion-icon>
          QuickToGo
        </ion-item>
      </div>

      <div *ngIf="showCity" class="premium-option" (click)="onCreate('gift')">
        <ion-item button detail="false">
          <ion-icon name="gift-outline"></ion-icon>
          {{ '_gift_box_' | translate }}
        </ion-item>
      </div>

      <div *ngIf="showMessengerClub" class="premium-option" (click)="onCreate('messenger')">
        <ion-item button detail="false">
          <ion-icon name="chatbubble-ellipses-outline"></ion-icon>
          {{ '_messenger_club_' | translate }}
        </ion-item>
      </div>
    </ng-container>


    <ng-container *ngIf="isBookletOverview">
        <div *ngIf="showSms" class="premium-option" (click)="onCreate('sms')">
            <ion-item button detail="false">
                <ion-icon name="chatbubble-ellipses-outline"></ion-icon>
                {{ '_create_sms_message_' | translate }}
            </ion-item>
        </div>

      <div *ngIf="showBooklet" class="premium-option" (click)="onCreate('booklet')">
        <ion-item button detail="false">
          <ion-icon name="book-outline"></ion-icon>
          {{ '_create_local_offer_' | translate }}
        </ion-item>
      </div>
    </ng-container>

  </div>
</ion-list>
